export const BitbucketMarkInverse = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.884 20.1899H29.071L27.426 29.7999H20.605L12.604 39.3269C12.604 39.3269 12.963 39.6709 13.52 39.6709L34.812 39.6669C35.324 39.6669 35.761 39.2949 35.844 38.7899L38.883 20.1899H38.884Z"
      fill="url(#paint0_linear_818_531)"
    />
    <path
      d="M8.73796 10.3291C8.09296 10.3291 7.60196 10.9071 7.70596 11.5441L12.13 38.4841C12.186 38.8231 12.36 39.1161 12.606 39.3271C12.606 39.3271 12.965 39.6721 13.522 39.6721L21.759 29.8011H20.606L18.79 20.1911H38.885L40.295 11.5501C40.399 10.9141 39.908 10.3361 39.263 10.3361L8.73796 10.3291Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_531"
        x1="40.186"
        y1="24.4579"
        x2="24.84"
        y2="34.8449"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.072" stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
